export default __webpack_public_path__ + "static/media/employees.5c71fa26.svg";